// extracted by mini-css-extract-plugin
export default {"zoomModal":"m1-z","image":"n1-z","button":"o1-z","isOverlayShown":"p1-z"};